function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.05 8.29a.5.5 0 01.45-.28h5c.19 0 .36.11.45.28.09.17.07.37-.05.52l-2.5 3.33a.48.48 0 01-.4.2.48.48 0 01-.4-.2L9.1 8.81a.51.51 0 01-.05-.52zm8.56 2.15l-5 7a.74.74 0 01-.61.31c-.24 0-.47-.12-.61-.31l-5-7a.76.76 0 01.17-1.05.76.76 0 011.05.17L12 15.71l4.39-6.15c.24-.34.71-.42 1.05-.17.33.24.41.71.17 1.05z"
})));